import { Moment } from 'moment';

/**
 * Wrapper for the MomentJs helper functions
 * @returns - Helper functions for using MomentJS
 */
export const useMomentJs = () => {
	/**
	 * Takes in a time and modifies it to the given interval.
	 * taken from https://github.com/moment/moment/issues/959#issuecomment-301767843
	 * @param interval - Nearest chosen interval E.G. 5,10,15,30,etc... minutes
	 * @param time - Time as MomentJS object
	 * @returns - MomentJs object with the nearest interval
	 */
	const nearestMinutes = (interval: number, time: Moment): Moment => {
		const roundedMinutes = Math.round(time.clone().minute() / interval) * interval;
		return time.clone().minute(roundedMinutes).second(0);
	};

	return {
		nearestMinutes,
	};
};
